/**
 * Phone E.164 pattern — Zod-free primitive constants.
 *
 * Shared between `@artemis/validators`' `phoneSchema` (Zod) and the
 * identity domain value objects. Domain layer imports these constants
 * through the `@artemis/validators/policies` subpath (AUDIT-107 boundary
 * discipline: domain may depend on primitive constants but not on Zod at
 * runtime).
 *
 * Wire format: `^\+[1-9]\d{1,14}$`
 *   - `+`           literal plus sign
 *   - `[1-9]`       one non-zero leading digit (country code start)
 *   - `\d{1,14}`    1-14 more ASCII digits (no `u` flag → ASCII-only)
 *
 * Smallest valid: `+12`  (3 chars)
 * Largest valid:  `+999999999999999` (16 chars: `+` + 15 digits)
 */
export const PHONE_PATTERN = /^\+[1-9]\d{1,14}$/;
export const PHONE_ERROR_MESSAGE = 'must be E.164 (+ followed by 2–15 digits)';
//# sourceMappingURL=phone.js.map